import { SVGProps } from 'react';

export default function SKUTag(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
      <mask id="mask0_7668_17733" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="29" height="28">
        <path d="M0.25 8.2016e-05H28.2499V28H0.25V8.2016e-05Z" fill="white" />
      </mask>
      <g mask="url(#mask0_7668_17733)">
        <path
          d="M24.234 13.8478L24.2373 24.5109C23.5449 26.0077 19.2813 27.1797 14.25 27.1797C9.21856 27.1797 4.95497 26.0077 4.26257 24.5109L4.26585 13.8478"
          stroke="black"
          strokeWidth="1.64"
          strokeMiterlimit="22.926"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.2234 18.5939L24.2234 18.6004C24.2234 20.7404 19.755 22.4751 14.243 22.4751C8.79316 22.4751 4.35097 20.7779 4.26379 18.6624"
          stroke="black"
          strokeWidth="1.64"
          strokeMiterlimit="22.926"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.60547 0.820322V4.10156"
          stroke="black"
          strokeWidth="1.64"
          strokeMiterlimit="22.926"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.707 0.820322H13.3476C13.7988 0.820322 14.168 1.18946 14.168 1.64063V3.28125C14.168 3.73242 13.7988 4.10156 13.3476 4.10156H11.707C11.2559 4.10156 10.8867 3.73242 10.8867 3.28125V1.64063C10.8867 1.18946 11.2559 0.820322 11.707 0.820322Z"
          stroke="black"
          strokeWidth="1.64"
          strokeMiterlimit="22.926"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.12493 10.6064C7.82142 10.4859 7.60535 10.1887 7.60535 9.84356V8.20294C7.60535 7.75177 7.97454 7.38263 8.42566 7.38263H10.0663C10.5175 7.38263 10.8866 7.75177 10.8866 8.20294V9.84356"
          stroke="black"
          strokeWidth="1.64"
          strokeMiterlimit="22.926"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1678 9.84375V8.20313C14.1678 7.75196 14.537 7.38282 14.9882 7.38282H16.6288C17.08 7.38282 17.4491 7.75196 17.4491 8.20313V9.84375C17.4491 9.86213 17.4485 9.88039 17.4473 9.89844"
          stroke="black"
          strokeWidth="1.64"
          strokeMiterlimit="22.926"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.8944 7.38277V10.6641"
          stroke="black"
          strokeWidth="1.64"
          strokeMiterlimit="22.926"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4492 0.820322V4.10156"
          stroke="black"
          strokeWidth="1.64"
          strokeMiterlimit="22.926"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.7305 0.820322V4.10156"
          stroke="black"
          strokeWidth="1.64"
          strokeMiterlimit="22.926"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.243 17.7461C19.7401 17.7461 24.2234 16.0056 24.2234 13.8714C24.2234 11.7374 19.7401 9.99684 14.243 9.99684C8.74595 9.99684 4.26257 11.7374 4.26257 13.8714C4.26257 16.0056 8.74595 17.7461 14.243 17.7461Z"
          stroke="black"
          strokeWidth="1.64"
          strokeMiterlimit="22.926"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
